import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to top whenever the route pathname changes.
 * Drop this component once inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const maxAttempts = 15;
      const tryScrollToHash = () => {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        attempts += 1;
        if (attempts < maxAttempts) {
          window.setTimeout(tryScrollToHash, 50);
          return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      };
      tryScrollToHash();
      return;
    }
    // Use 'instant' so users don't see a scroll animation on every nav
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
